module.exports = __webpack_public_path__ + "img/milanesapapas.aec40376.jpeg";